import styled from '@emotion/styled'
import { container } from './platformLinkStyles'

const Container = styled.div`
  ${container};
`

export default Container



// WEBPACK FOOTER //
// ./src/routes/home/components/Container.js